import Vue from "vue"

Vue.directive('longpress', {
    bind(el, binding, vNode) {

        if (!binding || !binding.value || typeof binding.value !== 'function') {
            const componentName: string | undefined = vNode?.context?.$options.name
            let warning: string = ""
            if (componentName) warning += `[v-longpress]: error in ${componentName}:\n`
            warning += `provided expression ${binding.expression} is not a function`
            console.warn(warning)
        }

        let pressTimer: any = null
        let start = (e: any) => {
            let scrollPos = document?.body?.scrollTop
            if (e.type == 'click' && e.button !== 0)
                return
            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    if (document?.body?.scrollTop == scrollPos) // only commence with longpress event if user hasn't scrolled
                        handler(e)
                }, 600)
            }
        }

        let cancel = (e: any) => {
            if (pressTimer !== null) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }

        const handler = (e: any) => {
            var arg: any = binding.arg || e
            binding.value(arg)
        }

        const addEventListeners = (el: HTMLElement, events: string[], runner: Function | any) => {
            events.forEach((event) => {
                el.addEventListener(event, runner)
            })
        }

        const startEvents: string[] = ["mousedown", "touchstart"]
        const cancelEvents: string[] = ["click", "mouseout", "touchend", "touchcancel"]
        addEventListeners(el, startEvents, start)
        addEventListeners(el, cancelEvents, cancel)
    }
})